import React, { useEffect } from 'react';
import { Row, Col } from 'reactstrap';

const types = ['Accumulation', 'Purchase', 'Pending', 'Balance'];

const CalculationHeader = ({ activeType, onUpdateType,rowData }) => {

  return (
    <Row className="my-2 acc-Details">
      <Col
        onClick={() => onUpdateType('Accumulation')}
        className={`px-3 py-2 rounded-1 ${activeType === 'Accumulation'
          ? 'bg-primary text-white border-primary'
          : 'text-dark border'
          }`}
      >
        <Row className="my-1 align-items-center">
          {' '}
          <Col>
            <h5 className="font-weight-500 mb-0 f-16">
              Accumulations
            </h5>
          </Col>
          <Row>
            <Col xs="auto">
              <span className="font-weight-500">{rowData.accumulations||0}</span>
            </Col>
          </Row>
        </Row>
      </Col>
      <Col xs="auto" className="my-auto">
        <span className="inventory-calculation-icon">+</span>
      </Col>
      <Col
        onClick={() => onUpdateType('Adjustment')}
        className={`px-2 py-2 rounded-1 ${activeType === 'Adjustment'
          ? 'bg-primary text-white border-primary'
          : 'text-dark border'
          }`}
      >
        <Row className="my-1 align-items-center">
          {' '}
          <Col>
            <h5 className="font-weight-500 mb-0 f-16">
              Adjustments
            </h5>
          </Col>
          <Row>
            <Col xs="auto">
              <span className="font-weight-500">{rowData.adjustmentUnits||0}</span>
            </Col>
          </Row>
        </Row>
      </Col>
      
      <Col xs="auto" className="my-auto">
        <span className="inventory-calculation-icon">-</span>
      </Col>
      <Col
        onClick={() => onUpdateType('Pending')}
        className={`px-3 py-2 rounded-1 ${activeType === 'Pending'
          ? 'bg-primary text-white border-primary'
          : 'text-dark border'
          }`}
      >
        <Row className="my-1 align-items-center">
          {' '}
          <Col>
            <h5 className="font-weight-500 mb-0 f-16">
              Pending
            </h5>
          </Col>
          <Row>
            <Col xs="auto">
              <span className="font-weight-500">{rowData.onOrderedUnits || 0}</span>
            </Col>
          </Row>
        </Row>
      </Col>
      <Col xs="auto" className="my-auto">
        <span className="inventory-calculation-icon">-</span>
      </Col>
      <Col
        onClick={() => onUpdateType('Purchase')}
        className={`px-3 py-2 rounded-1 ${activeType === 'Purchase'
          ? 'bg-primary text-white border-primary'
          : 'text-dark border'
          }`}
      >
        <Row className="my-1 align-items-center">
          {' '}
          <Col>
            <h5 className="font-weight-500 mb-0 f-16">
              Purchases
            </h5>
          </Col>
          <Row>
            <Col xs="auto">
              <span className="font-weight-500">{rowData.orderedUnits || 0}</span>
            </Col>
          </Row>
        </Row>
      </Col>
      <Col xs="auto" className="my-auto">
        <span className="inventory-calculation-icon">=</span>
      </Col>
      <Col
        className={`px-3 py-2 rounded-1 ${activeType === 'Balance'
          ? 'bg-primary text-white border-primary'
          : 'text-dark border'
          }`}
      >
        <Row className="my-1 align-items-center">
          {' '}
          <Col>
            <h5 className="font-weight-500 mb-0 f-16">
              Balance
            </h5>
          </Col>
          <Row>
            <Col xs="auto">
              <span className="font-weight-500">{rowData.balance}</span>
            </Col>
          </Row>
        </Row>
      </Col>
    </Row>
  );
};

export default CalculationHeader;
